import { createAction } from 'typesafe-actions';
import { ACTIONS } from './types';

export const toggleScoreboardAction = createAction(ACTIONS.TOGGLE_SCOREBOARD)();
